
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pom",
      function () {
        return require("private-next-pages/pom.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pom"])
      });
    }
  